import styled from "styled-components";
import headerimage from "./images/sammal.webp";
import headerPlaceholder from "./images/sammal-placeholder.webp"; // Very small, blurred version
import headerimageSmall from "./images/sammal-small.webp"; // Mobile version
import headerimageMedium from "./images/sammal-medium.webp"; // Tablet version
import concertsBgImg from "./images/liveimage.webp";
import releasesBgImg from "./images/sumukuva.jpg";
import contactBgImg from "./images/luola.webp";
import { FaBars } from "react-icons/fa";

export const Bars = styled(FaBars)`
  display: none;
  color: #c7c5c5;
  transition: color 0.3s ease;

  @media screen and (max-width: 992px) {
    display: block;
    font-size: 1.8rem;
    cursor: pointer;
    padding: 0.5rem;
    background: rgba(0, 0, 0, 0.7);
    backdrop-filter: blur(10px);
    border: 1px solid rgba(78, 102, 78, 0.3);
    border-radius: 6px;

    &:hover {
      color: #4e664e;
      background: rgba(0, 0, 0, 0.9);
      border-color: #4e664e;
    }
  }
`;

export const NavMenu = styled.div`
  display: flex;
  align-items: center;
  margin-right: -24px;
  @media screen and (max-width: 992px) {
    display: none;
  }
`;

export const BandContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  align-items: center;

  p {
    max-width: 100%;
    width: auto;
    height: auto;
    line-height: 1.8;
    color: #c7c5c5;
  }

  blockquote {
    max-width: 100%;
    margin: 1.5rem 0 0;
    padding-left: 1rem;
    border-left: 3px solid rgba(78, 102, 78, 0.45);
    line-height: 1.8;
    color: #c7c5c5;

    p {
      margin: 0 0 0.75rem;
    }

    footer {
      font-size: 0.95rem;
      font-style: normal;
    }

    a {
      color: #8fb38f;
      text-decoration: none;

      &:hover {
        color: #4e664e;
        text-decoration: underline;
      }
    }
  }

  img {
    max-width: 100%;
    width: auto;
    height: auto;
    opacity: 0.85;
    border-radius: 12px;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.6);
    transition: all 0.3s ease;

    &:hover {
      opacity: 1;
      transform: translateY(-4px);
      box-shadow: 0 12px 40px rgba(0, 0, 0, 0.7);
    }
  }

  @media (min-width: 1000px) {
    flex-direction: row;
    align-items: flex-start;
    gap: 3rem;

    p {
      display: block;
      max-width: 600px;
      width: auto;
      height: auto;
      flex: 1;
    }

    blockquote {
      max-width: 600px;
      flex: 1;
    }

    img {
      margin-left: 0;
      display: block;
      max-width: 500px;
      width: auto;
      height: auto;
      margin-bottom: 0;
      flex-shrink: 0;
    }
  }
`;

export const ReleasesBg = styled.div`
  z-index: 4;
  border: none;
  border-radius: 12px;
  background-image: url(${releasesBgImg});
  background-size: cover;
  background-position: center;
  background-attachment: fixed;
  position: relative;
  overflow: hidden;
  padding: 3rem 2rem;
  margin: 2rem 0;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.6);

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.75);
    backdrop-filter: blur(2px);
    z-index: -1;
  }

  h2 {
    color: #4e664e !important;
    text-shadow: 0 2px 8px rgba(0, 0, 0, 0.9),
                 0 0 16px rgba(78, 102, 78, 0.4) !important;
    position: relative;
    z-index: 1;
  }

  a {
    font-size: 1.5em !important;
    line-height: 1.8 !important;
    position: relative;
    z-index: 1;
    transition: all 0.3s ease;

    &:hover {
      color: #f5f5f5 !important;
      text-decoration: none !important;
      text-shadow: 0 0 12px rgba(78, 102, 78, 0.6) !important;
    }
  }
`;

export const ConcertsBg = styled.div`
  z-index: 4;
  border: none;
  border-radius: 12px;
  background-image: url(${concertsBgImg});
  background-size: cover;
  background-position: center;
  background-attachment: fixed;
  position: relative;
  overflow: hidden;
  padding: 3rem 2rem;
  margin: 2rem 0;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.6);

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.75);
    backdrop-filter: blur(2px);
    z-index: -1;
  }

  h2 {
    color: #4e664e !important;
    text-shadow: 0 2px 8px rgba(0, 0, 0, 0.9),
                 0 0 16px rgba(78, 102, 78, 0.4) !important;
    position: relative;
    z-index: 1;
  }
`;

export const ContactBg = styled.div`
  z-index: 4;
  border: none;
  border-radius: 12px;
  background-image: url(${contactBgImg});
  background-size: cover;
  background-position: center;
  background-attachment: fixed;
  position: relative;
  overflow: hidden;
  padding: 3rem 2rem;
  margin: 2rem 0;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.6);

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.75);
    backdrop-filter: blur(2px);
    z-index: -1;
  }

  h2 {
    color: #4e664e !important;
    text-shadow: 0 2px 8px rgba(0, 0, 0, 0.9),
                 0 0 16px rgba(78, 102, 78, 0.4) !important;
    position: relative;
    z-index: 1;
  }
`;

export const ComponentContainer = styled.div`
  margin-left: auto;
  margin-right: auto;
  padding: 0 1.5rem;
  max-width: 100%;

  /* Global link hover styling */
  a:hover {
    color: #f5f5f5 !important;
    text-decoration: none !important;
  }

  /* Medium devices (landscape tablets, 768px and up) */
  @media only screen and (min-width: 768px) {
    padding: 0 3rem;
    max-width: 1200px;
  }

  /* Large devices (laptops/desktops, 992px and up) */
  @media only screen and (min-width: 1200px) {
    padding: 0 4rem;
    max-width: 1400px;
  }
`;

export const ComponentBg = styled.div`
  background: #0a0a0a;
  min-height: calc(100vh - 200px);
  padding-bottom: 120px;
`;

export const HeaderContainer = styled.div`
  position: relative;
  min-height: 50vh;

  /* Logo positioning and visibility */
  #home img {
    max-width: 30%;
    margin-left: 130px;
    position: relative;
    transition: opacity 0.3s;
    width: 100%;
    height: auto;

    &.hidden {
      display: none;
    }

    &.placeholder {
      display: flex;
      filter: blur(5px);
    }

    &.loaded {
      display: flex;
    }

    @media only screen and (max-width: 767px) {
      padding-top: 40px;
      filter: drop-shadow(3px 3px 6px rgba(0, 0, 0, 0.9));
      max-width: 40% !important; /* Reduced from 80% to 60% */
      margin-left: 30% !important; /* Center the logo */

      &.placeholder {
        filter: blur(5px) drop-shadow(3px 3px 6px rgba(0, 0, 0, 0.9));
      }
    }
  }

  /* Load placeholder first */
  background: url(${headerPlaceholder}) no-repeat center top;
  background-size: contain;

  /* Then load high-quality image */
  &::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: url(${headerimage}) no-repeat center top;
    background-size: contain;
    opacity: 0;
    transition: opacity 0.3s ease-in-out;
    z-index: -1;
  }

  &.loaded::after {
    opacity: 1;
  }

  /* Mobile - full width and taller height */
  @media only screen and (max-width: 767px) {
    min-height: 30vh;
    margin-right: -30px;
    width: calc(100vw);
    background-image: url(${headerimageSmall});
    background-size: cover;
    background-position: center center;

    &::after {
      background-size: cover;
      background-position: center center;
    }
  }

  /* Tablet - half height */
  @media only screen and (min-width: 768px) {
    min-height: 30vh;
    background-image: url(${headerimageMedium});
    background-size: cover;
    background-position: center top;

    &::after {
      background-size: cover;
      background-position: center top;
    }
  }

  /* Desktop - half height */
  @media only screen and (min-width: 1200px) {
    min-height: 50vh; /* Half of the original 100vh */
    background-image: url(${headerimage});
    background-size: cover;
    background-position: center top;

    &::after {
      background-size: cover;
      background-position: center top;
    }
  }
`;

export const Navigation = styled.div`
  position: absolute;
  background: #a3c8a3;
  padding: 1em;
`;

export const Button = styled.button`
  background: rgba(0, 0, 0, 0.8);
  backdrop-filter: blur(10px);
  font-size: 1em;
  font-weight: 500;
  color: #c7c5c5;
  padding: 0.75em 1.5em;
  border: 2px solid #4e664e;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.4);

  &:hover {
    color: #f5f5f5 !important;
    background: rgba(78, 102, 78, 0.2) !important;
    border-color: #6b8b6b !important;
    text-decoration: none !important;
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(78, 102, 78, 0.3);
  }

  &:active {
    transform: translateY(0);
  }
`;

export const Table = styled.table`
  caption-side: top;
  border: none;
  border-collapse: collapse;

  caption-side: bottom;
  td,
  th {
    border: none;
  }

  td {
    padding: 5px 10px;
  }

  tbody tr {
    :nth-of-type(odd) {
      background-color: #efefef;
    }
    :hover {
      background-color: #759975;
    }
  }
  thead > tr {
    background-color: #c2c2c2;
  }
  caption {
    font-size: 0.9em;
    padding: 5px;
    font-weight: bold;
  }
`;

export const ImageContainer = styled.div`
  z-index: 5;

  margin-top: 16px;
  height: 300px;
`;

export const StyledImage = styled.div`
  z-index: 5;
  display: block;
  height: 100%;
  width: 100%;
  object-fit: cover;
`;

export const FooterStyle = styled.div`
  background: rgba(0, 0, 0, 0.95);
  backdrop-filter: blur(20px);
  color: #696969;
  position: fixed;
  left: 0;
  bottom: 0;
  height: auto;
  width: 100%;
  z-index: 3;
  text-align: center;
  box-shadow: 0 -4px 16px rgba(0, 0, 0, 0.5);
  border-top: 1px solid rgba(78, 102, 78, 0.15);
  padding: 0.75rem 0;
  margin: 0;

  /* Remove underlines from all footer links */
  a {
    text-decoration: none !important;
    transition: all 0.3s ease;

    &:hover {
      text-decoration: none !important;
      color: inherit !important;
    }
  }

  @media only screen and (max-width: 767px) {
    padding: 0.5rem 0;
  }
`;

/* Hide Curator.io "Powered by" branding */
export const GalleryContainer = styled.div`
  /* Completely remove the second post from layout */
  #curator-feed-default-feed-layout .crt-feed .crt-post:nth-child(2) {
    display: none !important;
  }

  /* Hide posts containing the powered-by background image */
  #curator-feed-default-feed-layout .crt-post:has(div[style*="powered-by"]) {
    display: none !important;
  }

  /* Hide posts with curator_io aria-label */
  #curator-feed-default-feed-layout .crt-post:has(div[aria-label*="curator_io"]) {
    display: none !important;
  }

  /* Alternative selectors for branding posts */
  #curator-feed-default-feed-layout .crt-feed .crt-post[data-crt-source="curator"],
  #curator-feed-default-feed-layout .crt-feed .crt-post.crt-branding {
    display: none !important;
  }

  /* Hide specific Curator.io branding link */
  a.crt-logo.crt-tag,
  a[href="https://curator.io"].crt-logo.crt-tag {
    display: none !important;
  }

  /* Direct targeting of branding div */
  div[style*="powered-by-v3.png"],
  div[aria-label*="curator_io"] {
    display: none !important;
  }

  /* Let Curator.io handle the grid layout, just fix gaps */
  #curator-feed-default-feed-layout .crt-feed {
    display: flex !important;
    flex-wrap: wrap !important;
    justify-content: flex-start !important;
    gap: 15px !important;
  }

  /* Reset posts to natural sizing */
  #curator-feed-default-feed-layout .crt-feed .crt-post {
    flex: 0 0 auto !important;
    margin: 0 !important;
  }

  /* Style Load more button to match Send button */
  #curator-feed-default-feed-layout .crt-feed-more button,
  #curator-feed-default-feed-layout .crt-load-more,
  .crt-load-more-button {
    background: rgba(0, 0, 0, 0.8) !important;
    backdrop-filter: blur(10px) !important;
    font-size: 1em !important;
    font-weight: 500 !important;
    color: #c7c5c5 !important;
    padding: 0.75em 1.5em !important;
    border: 2px solid #4e664e !important;
    border-radius: 8px !important;
    text-decoration: none !important;
    cursor: pointer !important;
    transition: all 0.3s ease !important;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.4) !important;

    &:hover {
      color: #f5f5f5 !important;
      background: rgba(78, 102, 78, 0.2) !important;
      border-color: #6b8b6b !important;
      text-decoration: none !important;
      transform: translateY(-2px) !important;
      box-shadow: 0 6px 20px rgba(78, 102, 78, 0.3) !important;
    }
  }
`;
